import { ofType } from "redux-observable";
import { merge } from "rxjs";
import { combineChecks } from "../../../guards/combineChecks";
import { guard } from "../../../guards/guard";
import { invert } from "../../../guards/invert";
import { pathEmpty } from "../../../guards/pathEmpty";
import { TypeActionShowMe } from "../../actionShowMe";
import { checkAnyBuildingWhichProducesResourceIdAvailable } from "../../checks/checkAnyBuildingWhichProducesResourceIdAvailable";
import { checkAnyBuildingWhichProducesResourceIdNotProducingAvailable } from "../../checks/checkAnyBuildingWhichProducesResourceIdNotProducingAvailable";
import { checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable } from "../../checks/checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable";
import { checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone } from "../../checks/checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone";
import { checkAnyBuildingWhichProducesResourceIdProductionDonePremiumAvailable } from "../../checks/checkAnyBuildingWhichProducesResourceIdProductionDonePremiumAvailable";
import { checkAnyBuildingWhichProducesResourceIdProductionInProgressAvailable } from "../../checks/checkAnyBuildingWhichProducesResourceIdProductionInProgressAvailable";
import { pathFocusBuildingConstructionDoneProductionDoneMaxLevel } from "../../path/pathFocusBuildingConstructionDoneProductionDoneMaxLevel";
import { pathFocusBuildingProductionDoneMaxLevelByResourceId } from "../../path/pathFocusBuildingProductionDoneMaxLevelByResourceId";
import { pathFocusPremiumBuildingProductionDoneMaxLevelByResourceId } from "../../path/pathFocusPremiumBuildingProductionDoneMaxLevelByResourceId";
import { pathSelectBuildingInBuildMenuByResourceId } from "../../path/pathSelectBuildingInBuildMenuByResourceId";
import { pathSelectBuildingMaxLevelByResourceId } from "../../path/pathSelectBuildingMaxLevelByResourceId";
import { pathSelectBuildingNotProducingMaxLevelByResourceId } from "../../path/pathSelectBuildingNotProducingMaxLevelByResourceId";
import { pathSelectBuildingProductionInProgressMaxLevelByResourceId } from "../../path/pathSelectBuildingProductionInProgressMaxLevelByResourceId";
export var epicShowMeCollectResource = function (action$, state$, deps) {
    // TODO: Could Naming be done based on shopCategory?
    var action1 = action$.pipe(ofType(TypeActionShowMe.QuestTaskCollectResource), guard(state$, deps, pathEmpty)([
        combineChecks([invert(checkAnyBuildingWhichProducesResourceIdAvailable)])(pathSelectBuildingInBuildMenuByResourceId),
    ]));
    var action2 = action$.pipe(ofType(TypeActionShowMe.QuestTaskCollectResource), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable,
            checkAnyBuildingWhichProducesResourceIdProductionDonePremiumAvailable,
        ])(pathFocusPremiumBuildingProductionDoneMaxLevelByResourceId),
    ]));
    var action3 = action$.pipe(ofType(TypeActionShowMe.QuestTaskCollectResource), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable,
            invert(checkAnyBuildingWhichProducesResourceIdProductionDonePremiumAvailable),
        ])(pathFocusBuildingProductionDoneMaxLevelByResourceId),
    ]));
    var action4 = action$.pipe(ofType(TypeActionShowMe.QuestTaskCollectResource), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            invert(checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable),
            checkAnyBuildingWhichProducesResourceIdProductionInProgressAvailable,
        ])(pathSelectBuildingProductionInProgressMaxLevelByResourceId),
    ]));
    var action5 = action$.pipe(ofType(TypeActionShowMe.QuestTaskCollectResource), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            invert(checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable),
            invert(checkAnyBuildingWhichProducesResourceIdProductionInProgressAvailable),
            checkAnyBuildingWhichProducesResourceIdNotProducingAvailable,
        ])(pathSelectBuildingNotProducingMaxLevelByResourceId),
    ]));
    var action6 = action$.pipe(ofType(TypeActionShowMe.QuestTaskCollectResource), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            invert(checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable),
            invert(checkAnyBuildingWhichProducesResourceIdProductionInProgressAvailable),
            invert(checkAnyBuildingWhichProducesResourceIdNotProducingAvailable),
            checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone,
        ])(pathFocusBuildingConstructionDoneProductionDoneMaxLevel),
    ]));
    var action7 = action$.pipe(ofType(TypeActionShowMe.QuestTaskCollectResource), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            invert(checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable),
            invert(checkAnyBuildingWhichProducesResourceIdProductionInProgressAvailable),
            invert(checkAnyBuildingWhichProducesResourceIdNotProducingAvailable),
            invert(checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone),
        ])(pathSelectBuildingMaxLevelByResourceId),
    ]));
    return merge(action1, action2, action3, action4, action5, action6, action7);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/collect-resource/epicShowMeCollectResource.ts
// module id = 2355
// module chunks = 3